import { SiteUrl } from '@mirai-kids-monte/core/src/constants/SiteUrl';

export const SITE_URL = SiteUrl.WEB;

export const DEFAULT_OGP_IMAGE_URL = `${SITE_URL}/img/image-montessori-tool-1.webp`;

const isAbsoluteUrl = (value: string) => value.startsWith('http://') || value.startsWith('https://');

export const buildCanonicalUrl = (path: string) => {
  if (isAbsoluteUrl(path)) {
    return path;
  }

  return `${SITE_URL}${path.endsWith('/') ? path : `${path}/`}`;
};

export const buildAbsoluteImageUrl = (imagePath: string) =>
  isAbsoluteUrl(imagePath) ? imagePath : `${SITE_URL}${imagePath}`;
